import { tmpPrivate, tmpPublic } from '~/amplify';

const isTemporaryImagePath = (s3key: string): boolean =>
  s3key.startsWith(tmpPrivate) || s3key.startsWith(tmpPublic);

export default isTemporaryImagePath;
